import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, Col, Row } from 'react-bootstrap';
import { SubNav } from '../../layout/submenu';
import { Unit } from '../../../helpers/unit';
import { searchWord } from '../../../helpers/common';
import { DataTable } from '../../widgets';
import { EVENT_CLEAR_STREAM, STREAM_FETCHED, STREAM_FETCHING } from './GPSPlayer';
import "../../../../assets/scss/travelled-distance-popup.scss";

const ReplayEGListWindow = (props) => {
    const unit = Unit.getInstance();

    const settings = useSelector(state => state.user.settings);

    const [searchText, setSearchText] = useState("");
    const [egList, setEGList] = useState([]);
    const [isFetchingDistance, setIsFetchingDistance] = useState(false);

    useEffect(() => {
        const newEGList = extractEGList(props.gpsPlayer.gpsPoints, props.gpsPlayer.egIdWiseList);
        setEGList(newEGList);
        props.gpsPlayer.addListener(STREAM_FETCHING, null, () => {
            setEGList([]);
            setIsFetchingDistance(true);
        }).addListener(STREAM_FETCHED, null, () => {
            const newEGList = extractEGList(props.gpsPlayer.gpsPoints, props.gpsPlayer.egIdWiseList);
            setEGList(newEGList);
            setIsFetchingDistance(false);
        }).addListener(EVENT_CLEAR_STREAM, null, () => {
            setEGList([]);
            setIsFetchingDistance(false);
        });
    }, []);

    const extractEGList = (gpsPoints, egIdWiseList) => {
        let egTravelledDistance = {};
        gpsPoints && Object.keys(gpsPoints).map(eg => {
            const distance = gpsPoints[eg].reduce((prev, curr) =>
                prev + curr.distance, 0);
            egTravelledDistance[eg] = distance;
            return distance;
        });

        const selectedEGDistance = egTravelledDistance && Object.keys(egTravelledDistance)
            .filter(item => egIdWiseList[item].isTruck)
            .map(e => {
                const eg = {
                    egName: egIdWiseList[e].name,
                    egId: egIdWiseList[e].egId,
                    egImg: egIdWiseList[e].smallImgUrl,
                    distance: egTravelledDistance && egTravelledDistance[e] ? egTravelledDistance[e] / 1609.344 : 0
                };
                return eg;
            });
        return selectedEGDistance;
    };

    const getFilteredList = (isSearchText) => {
        let filteredList = egList;
        if (isSearchText) {
            const isSearchTextMatched = value => searchWord(value, searchText);
            if (searchText.trim().length > 0) filteredList = filteredList.filter(e => {
                return isSearchTextMatched(e.egName);
            });
        }
        if (filteredList.length > 0) {
            filteredList.sort((a, b) =>
                b.distance - a.distance);
        }
        return filteredList;
    };

    const filteredList = getFilteredList(true);

    return <><Card className={`card-travelled-distance`}>
        <Card.Header>
            <div className="d-flex justify-content-between title-info">
                <Card.Title as="h6">Distance Travelled</Card.Title>
            </div>
        </Card.Header>
        <Card.Body>
            <SubNav.SearchBox
                placeholder="Equipment Group Name"
                value={searchText}
                onChange={e => setSearchText(e.target.value)}
                onClear={() => setSearchText("")}
            />
            {filteredList && filteredList.map((e, i) => {
                return (
                    <SubNav.Card className="m-1 mt-2 selected-eg" key={i}>
                        <Row className="p-2">
                            <Col lg={3} sm={3} md={3} className="text-center">
                                <img alt="" className="control-box-img" src={e.egImg} />
                            </Col>
                            <Col lg={9} sm={9} md={9} className="p-0">
                                <Row >
                                    <b>
                                        {e.egName}
                                    </b>
                                </Row>
                                <Row className="mt-1" >
                                    <SubNav.Name>
                                        {`${unit.toRoundOfDistance(e.distance)} ${settings.speedShortName === "mph" ? "miles" : "km"} `}
                                    </SubNav.Name>
                                </Row>
                            </Col>
                        </Row>
                    </SubNav.Card>
                );
            })
            }
            {isFetchingDistance && <DataTable.Loading className="mt-2" />}
            {(!isFetchingDistance && (Object.keys(props.gpsPlayer.gpsPoints).length === 0 || filteredList.length === 0)) && <DataTable.RecordsNotFound
                children={"No Equipment Group Found"} className="mt-4" />}
        </Card.Body>
    </Card>
    </>;
};

export default ReplayEGListWindow;